import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import SetupChargeService from "../../../../services/SetupChargeService";
import SetupChargesForm from "./forms/SetupChargesForm";

function SetupChargesAddEdit() {
  const { id } = useParams();
  let history = useHistory();

  const [formData, setData] = useState({
    ID: 0,
    Lookup: "",
    SingleColorPrice: "",
    MultiColorPrice: "",
  });

  const getData = async () => {
    const result = await SetupChargeService.getOne(id);
    if (result) setData(result);
  };

  useEffect(() => {
    getData();
  }, []);

  const saveSetupCharge = async (data) => {
    if (id) {
      // Edit Deco Method

      const postData = {
        ID: id,
        Lookup: data.lookup,
        SingleColorPrice: data.singleColorPrice,
        MultiColorPrice: data.multiColorPrice,
      };

      const result = await SetupChargeService.update(postData);
      if (result.success === true) {
        history.goBack();
      }
    } else {
      const postData = {
        Lookup: data.lookup,
        SingleColorPrice: data.singleColorPrice,
        MultiColorPrice: data.multiColorPrice,
      };
      const result = await SetupChargeService.add(postData);
      if (result.success === true) {
        history.goBack();
      }
    }
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} Setup Charge</h4>
      <hr />
      <SetupChargesForm formData={formData} submitForm={saveSetupCharge} />
    </div>
  );
}

export default SetupChargesAddEdit;
